import type { ReactNode } from 'react';

import type { FetchKeyProp } from '@woovi/relay';

import PixDialog from './PixDialog.tsx';
import PluginDialog from './PluginDialog.tsx';
import useStoreContext from '../store/useStoreContext.tsx';

type Props = {
  onClose: () => void;
  onCloseSuccess: () => void;
} & FetchKeyProp;

const PixDialogWrapper = (props: Props): ReactNode => {
  const { openPixState } = useStoreContext();

  if (!openPixState.modal) {
    return <PixDialog {...props} />;
  }

  return (
    <PluginDialog isOpen={openPixState.isOpen} onClose={props.onClose}>
      <PixDialog {...props} />
    </PluginDialog>
  );
};

export default PixDialogWrapper;
